import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Flex, theme } from "antd";
import { useHybridResponsive } from "../hooks";
import { RiBillLine } from "react-icons/ri";
import { HomeOutlined } from "@ant-design/icons";
import { Building } from "lucide-react";


interface NavItem {
  name: string;
  path: string;
  icon: React.ComponentType<{ style?: React.CSSProperties }>;
}

interface NavigationBarProps {
  items?: NavItem[];
  activeKey: string;
}

const defaultItems: NavItem[] = [
  { name: "Inicio", path: "/dashboard", icon: HomeOutlined },
  { name: "Empresa", path: "/empresa/dashboard", icon: Building },
  { name: "Facturación", path: "/facturas", icon: RiBillLine },
];

const NavigationBar: React.FC<NavigationBarProps> = ({
  items = [],
  activeKey,
}) => {
  const navigate = useNavigate();
  const { token } = theme.useToken();
  const { isMobile } = useHybridResponsive();

  const allItems = [...defaultItems, ...items];

  if (!isMobile) return null;

  return (
    <nav
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        height: 64,
        padding: "0 8px",
        background: (token as any).customBgBlur || "rgba(255, 255, 255, 0.85)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        borderTop: `1px solid ${token.colorBorderSecondary}`,
        boxShadow: "0 -1px 6px rgba(0,0,0,0.06)",
      }}
    >
      <Flex justify="space-around" align="center" style={{ height: "100%" }}>
        {allItems.map((item) => {
          const Icon = item.icon;
          const isActive = activeKey === item.path;

          return (
            <Button
              key={item.path}
              type="text"
              onClick={() => navigate(item.path)}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: 52,
                padding: "4px 16px",
                borderRadius: token.borderRadiusLG,
                background: isActive ? token.colorPrimaryBg : "transparent",
                color: isActive ? token.colorPrimary : token.colorTextSecondary,
                fontSize: 11,
                fontWeight: isActive ? 700 : 500,
                gap: 2,
                transition: "all 0.2s ease",
              }}
            >
              <Icon style={{ fontSize: 20 }} />
              {item.name}
            </Button>
          );
        })}
      </Flex>
    </nav>
  );
};

export default NavigationBar;
